import React from 'react';
import { useSelector } from 'react-redux';

import LoadingIndicator from '@swf/components/LoadingIndicator/LoadingIndicator';
import Translation from '@swf/components/Translation/Translation';
import { Message } from '@swf/sports/components';
import useMarketUpdates from '@swf/sports/hooks/useMarketUpdates';
import { isEventTemplate } from '@swf/sports/types/templates';
import { isCompoundMarketTemplate } from '@swf/sports/utils/isCompoundMarketTemplate';
import { notEmpty } from '@swf/sports/utils/notEmpty';

import { useSportsMatchFilteringWidget } from '../model';

import CompetitionPanel from './CompetitionPanel';
import { TXTWCL_No_matches_found } from './Results.messages.json';

const Results: React.FC = () => {
  const { widgetDispatch, widgetSelect } = useSportsMatchFilteringWidget();
  const templateGroups = useSelector(widgetSelect.templateGroups);
  const marketIds = useSelector(widgetSelect.marketIds);
  const showLoadingIndicator = useSelector(widgetSelect.showLoadingIndicator);

  useMarketUpdates(marketIds, widgetDispatch.marketsUpdated);

  if (showLoadingIndicator) {
    return <LoadingIndicator loading />; // TODO: GSFE-1689 Loading state / skeleton
  }

  if (!templateGroups.length) {
    return <Message message={<Translation {...TXTWCL_No_matches_found} />} />;
  }

  return (
    <>
      {templateGroups.map((competitionGroup) => {
        const firstTemplateInCompetition = competitionGroup[0][0].template;

        if (isEventTemplate(firstTemplateInCompetition)) {
          return (
            <CompetitionPanel
              key={`${firstTemplateInCompetition.eventId}_template_panel`}
              competitionGroup={competitionGroup}
              eventId={firstTemplateInCompetition.eventId}
            />
          );
        }

        return isCompoundMarketTemplate(firstTemplateInCompetition) ? (
          <CompetitionPanel
            key={`${firstTemplateInCompetition.marketIds.join('_')}_template_panel`}
            competitionGroup={competitionGroup}
            marketIds={firstTemplateInCompetition.marketIds.filter(notEmpty)}
          />
        ) : (
          <CompetitionPanel
            key={`${firstTemplateInCompetition.marketId}_template_panel`}
            competitionGroup={competitionGroup}
            marketId={firstTemplateInCompetition.marketId}
          />
        );
      })}
    </>
  );
};

export default Results;
